module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_is-object.js
// module id = 29
// module chunks = 1